/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

/* eslint-disable no-else-return */

import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../hooks/useAuthentication';
import { AuthenticationMode } from '../../model/types';
import { useSessionContext } from '@exo/frontend-common-session-context';
import { generateUrlWithLanguage } from '../../../../../../utils';
import { waitForRequestsToComplete } from '../../../../../../../packages/common/apollo/client/links/activeRequests';

export const LogoutButtonContainer = ({ authenticationMode = 'simple', render }: Props) => {
  const { logout } = useAuthentication();
  const navigate = useNavigate();
  const session = useSessionContext();

  if (authenticationMode === 'simple') {
    return render({
      onLogout: () => {
        logout();
        navigate(generateUrlWithLanguage('/', session?.language));
        //window.location.reload();
      }
    });
  } else {
    return render({
      onLogout: () => {
        logout();
        navigate(generateUrlWithLanguage('/', session?.language));
        //window.location.reload();
      }
    });
  }
};

type Props = {
  authenticationMode?: AuthenticationMode;
  render: (args: LogoutButtonContainerRenderProps) => ReactElement | null;
};

export type LogoutButtonContainerRenderProps = {
  onLogout?: () => Promise<void> | void;
};
